<template>
  <li :class="[ns.b(), { [ns.e('center')]: center }]">
    <div :class="[ns.e('tail'), ns.em('tail', size || '')]" />
    <div
      v-if="!$slots.dot"
      :class="defaultNodeKls"
      data-component-name="Timeline"
      data-event-name="click"
      data-event-content="点击时间点"
      :style="defaultNodeStyle"
    >
      <jd-icon v-if="icon" :class="ns.e('icon')">
        <component :is="icon" />
      </jd-icon>
    </div>
    <div
      v-if="$slots.dot"
      :class="ns.e('dot')"
      data-component-name="Timeline"
      data-event-name="click"
      data-event-content="点击时间点"
    >
      <slot name="dot" />
    </div>

    <div :class="[ns.e('wrapper'), ns.is('active', active)]">
      <div
        v-if="!hideTimestamp && placement === 'top'"
        :class="[ns.e('timestamp'), ns.is('top')]"
      >
        {{ timestamp }}
      </div>

      <div
        :class="[ns.e('content'), ns.em('content', size || '')]"
        data-component-name="Timeline"
        data-event-name="click"
        data-event-content="点击时间点内容"
      >
        <slot />
      </div>

      <div
        v-if="!hideTimestamp && placement === 'bottom'"
        :class="[ns.e('timestamp'), ns.is('bottom')]"
      >
        {{ timestamp }}
      </div>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { JdIcon } from '@jdesign-vue/components/icon'
import { useNamespace } from '@jdesign-vue/hooks'
import { timelineItemProps } from './timeline-item'

defineOptions({
  name: 'JdTimelineItem',
})

const props = defineProps(timelineItemProps)

const ns = useNamespace('timeline-item')
const defaultNodeKls = computed(() => [
  ns.e('node'),
  ns.em('node', props.size || ''),
  ns.em('node', props.type || ''),
  ns.is('hollow', props.hollow),
])
const defaultNodeStyle = computed(() => ({
  borderColor: props.color,
  borderStyle: 'solid',
  borderWidth: `var(${ns.cssVarName('border-width-1')})`,
  backgroundColor: props.hollow ? '' : props.color,
}))
</script>
